import { configValue } from 'config/appConfigUtils';

export function postSearchAlgoliaGetIndex() {
  return configValue('algolia', 'contentIndexName');
}
